import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

// http://gitlab.mobvista.com/playable/portal-backend/blob/master/support/doc/creative_review.md

/**
 * getReviewList
 * @param {Object} params
 * @param {number} params[].page
 * @param {number} params[].page_size
 * @param {number} params[].status
 * @param {string} [params[].offer_uuid]
 * @param {string} [params[].offer_name]
 * @param {string} [params[].campaign_name]
 * @param {number} [params[].offer_type]
 * @param {string} [params[].adv_name]
 * @param {number} [params[].creative_id]
 * @param {string} [params[].creative_name]
 * @param {number} [params[].creative_type]
 * @param {string} [params[].adv_entity]
 * @param {string} [params[].pm]
 * @param {string} [params[].operator]
 * @return {Promise<any>}
 */
export function getReviewList(params) {
  return request({
    url: `${v2Host}/creative/review/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * getReviewInfo
 * @param {number} id 审核id
 */
export function getReviewInfo(id) {
  return request({
    url: `${v2Host}/creative/review/info?id=${id}`,
    method: 'get',
  })
}

/**
 *
 * @param {{status: number, reason_ids: string, reason_text: string}} data
 * @return {Promise<any>}
 */
export function submitReview(data) {
  return request({
    url: `${v2Host}/creative/review/submit`,
    method: 'post',
    data: data,
  })
}

export function submitReAudit(data) {
  return request({
    url: `${v2Host}/creative/review/re-audit`,
    method: 'post',
    data,
  })
}

export function updateMaterialGrading(data) {
  return request({
    url: `${v2Host}/creative/review/update-grading`,
    method: 'post',
    data,
  })
}

/**
 * getSuggestList
 * @param {{field: string, keyword: string, status: number}} params
 * @return {Promise<any>}
 */
export function getSuggestList(params) {
  return request({
    url: `${v2Host}/creative/review/suggest`,
    method: 'get',
    params: params,
  })
}

/**
 * http://playable.dev.com:8067/?doc=creative_review/review.go#%2fcreative%2freview%2fpm-teams
 */
export function getPmTeams() {
  return request({
    url: `${v2Host}/creative/review/pm-teams`,
    method: 'get',
  })
}

/**
 * exportMaterialList
 * @param {Object} params
 * @param {number} params[].status
 * @param {string} [params[].offer_uuid]
 * @param {string} [params[].offer_name]
 * @param {string} [params[].campaign_name]
 * @param {number} [params[].offer_type]
 * @param {string} [params[].adv_name]
 * @param {number} [params[].creative_id]
 * @param {string} [params[].creative_name]
 * @param {number} [params[].creative_type]
 * @param {string} [params[].adv_entity]
 * @param {string} [params[].pm]
 * @param {string} [params[].operator]
 * @return {Promise<any>}
 */
export function exportMaterialList(params) {
  return request({
    url: `${v2Host}/creative/review/export`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
